import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  listContainer: {
    padding: 0,
    margin: 0,
    // paddingLeft: 15,
    paddingLeft: 24,
  },
  list: {
    color: theme.palette.secondary.main,
    padding: 0,
    margin: 0,
  },
  tooltip: {
    zIndex: 9999999999,
  },
  tooltipContent: {
    fontSize: 12,
    lineHeight: '12px',
    minWidth: 153,
    padding: '2px 0px',
    margin: 0,
  },
  info: {
    color: theme.palette.secondary.main,
  },
  successIcon: {
    color: theme.palette.success.main,
  },
  successTitle: {
    color: theme.palette.success.dark,
    textDecoration: 'line-through',
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
  errorTitle: {
    color: theme.palette.error.dark,
  },
}))

export default useStyles
